<template>
  <div class="page flex-col">
    <div class="block_1 flex-col">
      <div class="section_1 flex-row">
        <span class="text_1">面试时长：</span>
        <div class="box_1 flex-row">
          <span class="text_2">1小时</span>
          <img
            class="thumbnail_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng32bb5ffc73b63ed9396c4ca5c88708cf949f1f38de2bf548b59a76f324c084d7.png"
          />
        </div>
      </div>
    </div>
    <div class="group_6 flex-col">
      <div class="image-wrapper_6 flex-row">
        <img
          class="label_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng51ca0a9a82959510999af7ab8b6440a39f2d5261e3446450d9cd9676cdee8875.png"
        />
      </div>
      <div class="box_6 flex-row">
        <div class="text-wrapper_1 flex-col"><span class="text_3">提交</span></div>
      </div>
      <div class="section_4 flex-col">
        <div class="section_8 flex-row">
          <div class="box_7 flex-col">
            <div class="image-wrapper_7 flex-col">
              <img
                class="thumbnail_6"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngac0e50b7c61580100b1b64bf430e763b95e73091e710bb7cfd1cb2db7ff46fe5.png"
              />
            </div>
          </div>
        </div>
        <div class="section_9 flex-row">
          <div class="box_8 flex-col">
            <div class="box_9 flex-col"></div>
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngb51f4d8bf8adac0a747699d632371ee2596245a2fef5edfa2efa7919e5e2e770.png"
            />
          </div>
        </div>
        <div class="text-wrapper_4 flex-row"><span class="text_4">曹小亮个人简历.pdf</span></div>
      </div>
      <div class="box_10 flex-col">
        <div class="box_11 flex-row">
          <div class="box_12 flex-col">
            <div class="image-wrapper_8 flex-col">
              <img
                class="thumbnail_7"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngac0e50b7c61580100b1b64bf430e763b95e73091e710bb7cfd1cb2db7ff46fe5.png"
              />
            </div>
          </div>
        </div>
        <div class="box_13 flex-row">
          <div class="section_10 flex-col">
            <div class="box_14 flex-col"></div>
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngb51f4d8bf8adac0a747699d632371ee2596245a2fef5edfa2efa7919e5e2e770.png"
            />
          </div>
        </div>
        <div class="text-wrapper_5 flex-row"><span class="text_5">曹小亮岗位JD.pdf</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />